import React from "react";

import "./index.scss";

type Props = {
    style?: React.CSSProperties;
    variant: "white" | "blue" | "gray";
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    onClick?: () => void; // 親から渡されたクリックハンドラ
};
type MailProps = {
    style?: React.CSSProperties;
    children?: React.ReactNode;
    className?: string;
};


const Button: React.FC<Props> = ({
    style,
    variant,
    children,
    onClick,
    className,
    disabled,
}) => {
    return (
        <button
            onClick={onClick}
            style={style}
            className={`noto-sans-jp-extrabold ${className} button ${variant} ${disabled ? "disabled" : ""}`}
            disabled={disabled}
        >
            {children}
        </button>
    );
};
export const MailButton: React.FC<MailProps> = ({
    style,
    children,
    className,
}) => {
    const handleClick = () => {
        const email = "ecshop-info@saibugas-group.com";
        const subject =
            "##【件名は変更しないでください】西部ガスグループ公式オンラインショップに関するお問い合わせ";
        const body = "【お名前とお問い合わせ内容を以下にご記入ください】";
        const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        window.location.href = mailto;
    };
    return (
        <button
            onClick={handleClick}
            style={style}
            className={`noto-sans-jp-extrabold ${className} button`}
        >
            {children}
        </button>
    );
};
export default Button;
